import React from "react";
import SocialBase from "./SocialBase";
import AdFoxTGB5 from "./AdFoxTGB5";
export default function Social({ news, context }) {
    return (
        <div className="constructor__soc text-right mobile-hide">
            {/* <SocialBase news={news} className="social-desktop" /> */}
            <AdFoxTGB5 context={context} />
        </div>
    );
}
